import { createContext } from 'react'

import type { Api_Feed } from '@core/api'

import type { FeedQuery } from './types'

/**
 * Provides the raw feed object. Useful for sharing external feeds to hydrate
 * the widget.
 */
export const HydratedFeedContext = createContext<Api_Feed | undefined>(
  undefined,
)

/** Provides the feed query result. */
export const FeedQueryContext = createContext<FeedQuery | undefined>(undefined)
